import { BrancheRequestDtoBrancheEnum } from 'lib_api/lib/api/gen';

export type BrancheFormValue = {
  nature?: string;
  branche?: BrancheRequestDtoBrancheEnum;
};

export enum BrancheFormField {
  'NATURE' = 'NATURE',
  'BRANCHE' = 'BRANCHE',
}
